import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, where, limit, getDocs, doc, getDoc, orderBy } from 'firebase/firestore';

const EmailPreview = () => {
  const [welcomeView, setWelcomeView] = useState('html');
  const [followUpView, setFollowUpView] = useState('html');
  const [biWeeklyView, setBiWeeklyView] = useState('html');
  const [recentPedals, setRecentPedals] = useState([]);
  const [recentTrades, setRecentTrades] = useState([]);
  const [loading, setLoading] = useState(true);

  const welcomeEmailHTML = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Welcome to PedalxChange!</title>
  <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap" rel="stylesheet">
</head>
<body style="margin: 0; padding: 0; font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; background-color: #f5f5f5;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f5f5f5; padding: 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden;">
          <!-- Header -->
          <tr>
            <td style="padding: 30px; text-align: center; background-color: #ffffff;">
              <img src="https://pedalxchange.com/images/logo-email.png" alt="PedalxChange" style="max-width: 265px; height: auto;">
            </td>
          </tr>
          
          <!-- Content -->
          <tr>
            <td style="padding: 40px 30px;">
              <h1 style="color: #4A5759; font-size: 28px; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">Welcome to PedalxChange, TestUser!</h1>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                Thanks for joining our community, and experiencing the fastest and safest way for musicians to trade pedals.
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                To kick off your trading journey and start seeing potential matches, <strong>you first need to list a pedal.</strong>
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                This step is crucial because PXC's magic lies in our community's collective inventory. The more pedals you list, and the more users who participate, the better the matching algorithm works for everyone—including you! We're a collaborative network, and your participation directly increases the likelihood of finding that dream match for yourself and others.
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                Ready to start?
              </p>
              
              <div style="margin: 30px 0; text-align: center;">
                <a href="https://pedalxchange.com/pedalboard" style="display: inline-block; background-color: #C9A227; color: #ffffff; padding: 14px 28px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; margin-bottom: 15px; font-family: 'Nunito', sans-serif;">List a pedal</a>
              </div>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 30px 0 20px 0; font-family: 'Nunito', sans-serif;">
                We prioritize safe, transparent trading. You can read all the details about how PXC finds matches, initiates secure trades, and handles shipping logistics on our guide:
              </p>
              
              <div style="margin: 30px 0; text-align: center;">
                <a href="https://pedalxchange.com/how-it-works" style="display: inline-block; background-color: #C9A227; color: #ffffff; padding: 14px 28px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; font-family: 'Nunito', sans-serif;">Learn more about secure trading</a>
              </div>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 30px 0 20px 0; font-family: 'Nunito', sans-serif;">
                We are excited to have you join the PXC community. If you have any questions, please reach out to our team at <a href="mailto:contact@pedalxchange.com" style="color: #5A9ECB; text-decoration: none;">contact@pedalxchange.com</a>
              </p>
              
              <p style="color: #6b7280; font-size: 14px; line-height: 1.6; margin: 20px 0 0 0; font-family: 'Nunito', sans-serif;">
                Happy Trading,<br>
                The PedalxChange Team
              </p>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td style="padding: 20px 30px; background-color: #f9fafb; text-align: center; border-top: 1px solid #e5e7eb;">
              <p style="color: #6b7280; font-size: 12px; margin: 0 0 10px 0;">
                © ${new Date().getFullYear()} PedalxChange. All rights reserved.
              </p>
              <p style="color: #9ca3af; font-size: 11px; margin: 0;">
                This is an automated message. Please do not reply to this email.
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `;

  const welcomeEmailText = `Hi TestUser,

Welcome to PedalxChange!

Thanks for joining our community, and experiencing the fastest and safest way for musicians to trade pedals.

To kick off your trading journey and start seeing potential matches, you first need to list a pedal.

This step is crucial because PXC's magic lies in our community's collective inventory. The more pedals you list, and the more users who participate, the better the matching algorithm works for everyone—including you! We're a collaborative network, and your participation directly increases the likelihood of finding that dream match for yourself and others.

Ready to start?

List a pedal: https://pedalxchange.com/pedalboard

We prioritize safe, transparent trading. You can read all the details about how PXC finds matches, initiates secure trades, and handles shipping logistics on our guide:

Learn more about secure trading: https://pedalxchange.com/how-it-works

We are excited to have you join the PXC community. If you have any questions, please reach out to our team at contact@pedalxchange.com

Happy Trading,

The PedalxChange Team

---
© ${new Date().getFullYear()} PedalxChange. All rights reserved.
This is an automated message. Please do not reply to this email.`.trim();


  // Fetch recent pedals
  useEffect(() => {
    const fetchRecentPedals = async () => {
      try {
        const pedalsSnapshot = await getDocs(
          query(
            collection(db, 'listings'),
            where('active', '==', true),
            orderBy('createdAt', 'desc'),
            limit(30)
          )
        );

        const pedals = [];
        for (const docSnap of pedalsSnapshot.docs) {
          const pedalData = docSnap.data();
          
          // Skip pedals in trade or hidden
          if (pedalData.inTrade || pedalData.hiddenFromPedalboard) {
            continue;
          }
          
          // Calculate effective date (reactivatedAt takes precedence)
          const effectiveDate = pedalData.reactivatedAt 
            ? new Date(pedalData.reactivatedAt.seconds * 1000)
            : (pedalData.createdAt?.toDate?.() || new Date(pedalData.createdAt || 0));
          
          pedals.push({
            id: docSnap.id,
            ...pedalData,
            effectiveDate
          });
        }
        
        // Sort by effective date (newest first) and take 8
        pedals.sort((a, b) => b.effectiveDate - a.effectiveDate);
        setRecentPedals(pedals.slice(0, 8));
      } catch (error) {
        console.error('Error fetching recent pedals:', error);
        setRecentPedals([]);
      }
    };

    const fetchRecentTrades = async () => {
      try {
        const tradesSnapshot = await getDocs(
          query(
            collection(db, 'tradeOffers'),
            where('status', '==', 'complete'),
            limit(50)
          )
        );

        const mutualFiveStarTrades = [];
        
        for (const tradeDoc of tradesSnapshot.docs) {
          const trade = tradeDoc.data();

          // Mirrors the dashboard carousel and functions/welcomeEmails.js: a
          // trade an admin force-closed isn't a success story to showcase, even
          // if both parties left five stars afterwards.
          if (trade.completedBy === 'admin') {
            continue;
          }

          const hasInitiatorPedals = (trade.pedalSnapshots?.initiatorPedals && Array.isArray(trade.pedalSnapshots.initiatorPedals) && trade.pedalSnapshots.initiatorPedals.length > 0) || trade.pedalSnapshots?.initiatorPedal;
          if (!hasInitiatorPedals || !trade.pedalSnapshots?.responderPedal) {
            continue;
          }
          
          if (trade.fromUserFeedback?.rating !== 5 || trade.toUserFeedback?.rating !== 5) {
            continue;
          }
          
          const initiatorPedals = (trade.pedalSnapshots.initiatorPedals && Array.isArray(trade.pedalSnapshots.initiatorPedals))
            ? trade.pedalSnapshots.initiatorPedals
            : (trade.pedalSnapshots.initiatorPedal ? [trade.pedalSnapshots.initiatorPedal] : []);
          const hasInitiatorImages = initiatorPedals.some(p => p.images?.top);
          if (!hasInitiatorImages || !trade.pedalSnapshots.responderPedal?.images?.top) {
            continue;
          }
          
          const [fromUserSnap, toUserSnap] = await Promise.all([
            getDoc(doc(db, 'users', trade.fromUserId)),
            getDoc(doc(db, 'users', trade.toUserId))
          ]);
          
          if (!fromUserSnap.exists() || !toUserSnap.exists()) {
            continue;
          }
          
          mutualFiveStarTrades.push({
            id: tradeDoc.id,
            fromUserId: trade.fromUserId,
            toUserId: trade.toUserId,
            fromUserProfile: fromUserSnap.data(),
            toUserProfile: toUserSnap.data(),
            initiatorPedals: initiatorPedals,
            responderPedal: trade.pedalSnapshots.responderPedal,
            completedAt: trade.completedAt || trade.autoCompletedAt || trade.updatedAt || trade.createdAt
          });
        }
        
        const sorted = mutualFiveStarTrades.sort((a, b) => {
          const aTime = a.completedAt?.toDate?.()?.getTime?.() || (a.completedAt?.seconds ? a.completedAt.seconds * 1000 : 0);
          const bTime = b.completedAt?.toDate?.()?.getTime?.() || (b.completedAt?.seconds ? b.completedAt.seconds * 1000 : 0);
          if (!aTime && !bTime) return 0;
          if (!aTime) return 1;
          if (!bTime) return -1;
          return bTime - aTime;
        });
        
        const seenUserIds = new Set();
        const result = [];
        for (const trade of sorted) {
          if (result.length >= 3) break;
          if (seenUserIds.has(trade.fromUserId) || seenUserIds.has(trade.toUserId)) continue;
          seenUserIds.add(trade.fromUserId);
          seenUserIds.add(trade.toUserId);
          result.push(trade);
        }
        
        setRecentTrades(result);
      } catch (error) {
        console.error('Error fetching recent trades:', error);
        setRecentTrades([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentPedals();
    fetchRecentTrades();
  }, []);

  // Generate pedal grid HTML with real data (4x2 grid for follow-up email)
  const generatePedalGridHTML = () => {
    if (recentPedals.length === 0) {
      return '<p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: \'Nunito\', sans-serif; text-align: center;">New pedals are being added every day!</p>';
    }
    
    let html = '<table width="100%" cellpadding="0" cellspacing="0" style="margin: 20px 0;">';
    
    // Create 2 rows of 4 pedals each
    for (let row = 0; row < 2; row++) {
      html += '<tr>';
      for (let col = 0; col < 4; col++) {
        const index = row * 4 + col;
        const pedal = recentPedals[index];
        
        if (pedal) {
          const imageUrl = pedal.images?.top || pedal.images?.[0] || 'https://pedalxchange.com/images/default-pedal.png';
          const pedalName = `${pedal.make || ''} ${pedal.model || ''}`.trim() || 'Pedal';
          
          html += `
            <td style="padding: 5px; width: 25%; text-align: center; vertical-align: top;">
              <div style="width: 120px; height: 120px; margin: 0 auto; border-radius: 8px; overflow: hidden; background-color: #f3f4f6;">
                <img src="${imageUrl}" alt="${pedalName}" style="width: 120px; height: 120px; object-fit: cover; display: block;">
              </div>
              <p style="color: #4A5759; font-size: 12px; margin: 5px 0 0 0; font-family: 'Nunito', sans-serif; line-height: 1.3;">${pedalName}</p>
            </td>
          `;
        } else {
          html += '<td style="padding: 5px; width: 25%; vertical-align: top;"></td>';
        }
      }
      html += '</tr>';
    }
    
    html += '</table>';
    return html;
  };

  const generateTradeShowcaseHTML = () => {
    if (recentTrades.length === 0) {
      return '<p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: \'Nunito\', sans-serif; text-align: center;">Trades are happening every day!</p>';
    }
    
    let html = '<table width="100%" cellpadding="0" cellspacing="0" style="margin: 20px 0;">';
    
    for (const trade of recentTrades) {
      // fromUser received responderPedal, toUser received initiatorPedal(s)
      const fromUserPedalImage = trade.responderPedal?.images?.top || 'https://pedalxchange.com/images/default-pedal.png';
      const toUserPedalImages = (trade.initiatorPedals || []).filter(p => p.images?.top).map(p => p.images.top);
      const toUserPedalImage = toUserPedalImages[0] || 'https://pedalxchange.com/images/default-pedal.png';
      const fromUserPedalName = `${trade.responderPedal?.make || ''} ${trade.responderPedal?.model || ''}`.trim() || 'Pedal';
      const toUserPedalName = (trade.initiatorPedals || []).length > 1
        ? (trade.initiatorPedals || []).map(p => `${p.make || ''} ${p.model || ''}`.trim() || 'Pedal').join(' + ')
        : `${(trade.initiatorPedals || [])[0]?.make || ''} ${(trade.initiatorPedals || [])[0]?.model || ''}`.trim() || 'Pedal';
      
      const fromUserPhoto = trade.fromUserProfile?.photoURL || 'https://pedalxchange.com/images/default-avatar.png';
      const fromUsername = trade.fromUserProfile?.username || 'User';
      const toUserPhoto = trade.toUserProfile?.photoURL || 'https://pedalxchange.com/images/default-avatar.png';
      const toUsername = trade.toUserProfile?.username || 'User';
      
      html += `
        <tr>
          <td style="padding: 15px 0; border-bottom: 1px solid #e5e7eb;">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td style="width: 35%; text-align: center; vertical-align: middle;">
                  <div style="width: 100px; height: 100px; margin: 0 auto; border-radius: 8px; overflow: hidden; background-color: #f3f4f6;">
                    <img src="${fromUserPedalImage}" alt="${fromUserPedalName}" style="width: 100px; height: 100px; object-fit: cover; display: block;">
                  </div>
                  <table cellpadding="0" cellspacing="0" style="margin: 8px auto 0 auto;">
                    <tr>
                      <td style="padding-right: 5px; vertical-align: middle;">
                        <img src="${fromUserPhoto}" alt="${fromUsername}" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; display: block;">
                      </td>
                      <td style="padding-right: 5px; vertical-align: middle;">
                        <span style="color: #4A5759; font-size: 12px; font-family: 'Nunito', sans-serif;">${fromUsername}</span>
                      </td>
                      <td style="vertical-align: middle;">
                        <span style="color: #C9A227; font-size: 12px;">★★★★★</span>
                      </td>
                    </tr>
                  </table>
                </td>
                <td style="width: 30%; text-align: center; vertical-align: middle;">
                  <img src="https://pedalxchange.com/images/recent_trades_arrow.svg" alt="Double arrow" style="width: 60px; height: auto; display: block; margin: 0 auto;">
                </td>
                <td style="width: 35%; text-align: center; vertical-align: middle;">
                  ${toUserPedalImages.length > 1 ? `
                  <table cellpadding="2" cellspacing="0" style="margin: 0 auto;">
                    <tr>
                      ${toUserPedalImages.map(img => `<td><div style="width: 80px; height: 80px; border-radius: 4px; overflow: hidden; background-color: #f3f4f6;"><img src="${img}" alt="${toUserPedalName}" style="width: 80px; height: 80px; object-fit: cover; display: block;"></div></td>`).join('')}
                    </tr>
                  </table>
                  ` : `
                  <div style="width: 100px; height: 100px; margin: 0 auto; border-radius: 8px; overflow: hidden; background-color: #f3f4f6;">
                    <img src="${toUserPedalImage}" alt="${toUserPedalName}" style="width: 100px; height: 100px; object-fit: cover; display: block;">
                  </div>
                  `}
                  <table cellpadding="0" cellspacing="0" style="margin: 8px auto 0 auto;">
                    <tr>
                      <td style="padding-right: 5px; vertical-align: middle;">
                        <img src="${toUserPhoto}" alt="${toUsername}" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; display: block;">
                      </td>
                      <td style="padding-right: 5px; vertical-align: middle;">
                        <span style="color: #4A5759; font-size: 12px; font-family: 'Nunito', sans-serif;">${toUsername}</span>
                      </td>
                      <td style="vertical-align: middle;">
                        <span style="color: #C9A227; font-size: 12px;">★★★★★</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      `;
    }
    
    html += '</table>';
    return html;
  };

  // Generate follow-up email HTML with real data
  const followUpEmailHTML = loading ? `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Trades Are Happening Now on PedalxChange!</title>
  <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap" rel="stylesheet">
</head>
<body style="margin: 0; padding: 0; font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; background-color: #f5f5f5;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f5f5f5; padding: 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden;">
          <tr>
            <td style="padding: 40px 30px; text-align: center;">
              <p style="color: #4A5759; font-size: 16px; font-family: 'Nunito', sans-serif;">Loading email preview...</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  ` : `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Trades Are Happening Now on PedalxChange!</title>
  <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap" rel="stylesheet">
</head>
<body style="margin: 0; padding: 0; font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; background-color: #f5f5f5;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f5f5f5; padding: 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden;">
          <!-- Header -->
          <tr>
            <td style="padding: 30px; text-align: center; background-color: #ffffff;">
              <img src="https://pedalxchange.com/images/logo-email.png" alt="PedalxChange" style="max-width: 265px; height: auto;">
            </td>
          </tr>
          
          <!-- Content -->
          <tr>
            <td style="padding: 40px 30px;">
              <h1 style="color: #4A5759; font-size: 28px; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">Ready to list your first pedal, TestUser?</h1>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                While you've been gone, here's some of the latest inventory being added to PXC:
              </p>
              
              ${generatePedalGridHTML()}
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif;">
                These are just some of the newest pedals available for trading. Start listing today to generate matches with pedals like these, and more!
              </p>
              
              <div style="margin: 30px 0; text-align: center;">
                <a href="https://pedalxchange.com/pedalboard" style="display: inline-block; background-color: #C9A227; color: #ffffff; padding: 14px 28px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; font-family: 'Nunito', sans-serif;">List Your First Pedal</a>
              </div>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 30px 0 20px 0; font-family: 'Nunito', sans-serif;">
                While we're at it, here's a glimpse of some recent trades on PXC:
              </p>
              
              ${generateTradeShowcaseHTML()}
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif;">
                Kick-start your matching potential by adding to your Pedalboard today. Your perfect trade might already be waiting for you!
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif;">
                If you run into any issues or have questions about the process, please reach out to our team at <a href="mailto:contact@pedalxchange.com" style="color: #5A9ECB; text-decoration: none;">contact@pedalxchange.com</a>.
              </p>
              
              <p style="color: #6b7280; font-size: 14px; line-height: 1.6; margin: 20px 0 0 0; font-family: 'Nunito', sans-serif;">
                Happy Trading,<br>
                The PedalxChange Team
              </p>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td style="padding: 20px 30px; background-color: #f9fafb; text-align: center; border-top: 1px solid #e5e7eb;">
              <p style="color: #6b7280; font-size: 12px; margin: 0 0 10px 0; font-family: 'Nunito', sans-serif;">
                © ${new Date().getFullYear()} PedalxChange. All rights reserved.
              </p>
              <p style="color: #9ca3af; font-size: 11px; margin: 0; font-family: 'Nunito', sans-serif;">
                This is an automated message. Please do not reply to this email.
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `;

  const followUpEmailText = `Ready to list your first pedal, TestUser?

While you've been gone, here's some of the latest inventory being added to PXC.

These are just some of the newest pedals available for trading. Start listing today to generate matches with pedals like these, and more!

List Your First Pedal: https://pedalxchange.com/pedalboard

While we're at it, here's a glimpse of some recent trades on PXC. Trades are happening every day!

Kick-start your matching potential by adding to your Pedalboard today. Your perfect trade might already be waiting for you!

If you run into any issues or have questions about the process, please reach out to our team at contact@pedalxchange.com.

Happy Trading,

The PedalxChange Team

---
© ${new Date().getFullYear()} PedalxChange. All rights reserved.
This is an automated message. Please do not reply to this email.`.trim();

  // Generate bi-weekly match email HTML with real pedal data + sample match data
  const biWeeklyEmailHTML = loading ? `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Check Out the Latest on PedalxChange!</title>
  <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap" rel="stylesheet">
</head>
<body style="margin: 0; padding: 0; font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; background-color: #f5f5f5;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f5f5f5; padding: 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden;">
          <tr>
            <td style="padding: 40px 30px; text-align: center;">
              <p style="color: #4A5759; font-size: 16px; font-family: 'Nunito', sans-serif;">Loading email preview...</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  ` : `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Check Out the Latest on PedalxChange!</title>
  <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap" rel="stylesheet">
</head>
<body style="margin: 0; padding: 0; font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; background-color: #f5f5f5;">
  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f5f5f5; padding: 20px;">
    <tr>
      <td align="center">
        <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden;">
          <!-- Header -->
          <tr>
            <td style="padding: 30px; text-align: center; background-color: #ffffff;">
              <img src="https://pedalxchange.com/images/logo-email.png" alt="PedalxChange" style="max-width: 265px; height: auto;">
            </td>
          </tr>
          
          <!-- Content -->
          <tr>
            <td style="padding: 40px 30px;">
              <h1 style="color: #4A5759; font-size: 28px; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">Hey TestUser, check out the latest additions</h1>
              
              <!-- Browse Pedals Section -->
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                While you've been gone, here's some of the latest inventory being added to PXC:
              </p>
              
              ${generatePedalGridHTML()}
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif;">
                Click below to check out all the great things being added to the platform available for trade or purchase.
              </p>
              
              <div style="margin: 30px 0; text-align: center;">
                <a href="https://pedalxchange.com/latest-pedals" style="display: inline-block; background-color: #C9A227; color: #ffffff; padding: 14px 28px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; font-family: 'Nunito', sans-serif;">Browse Pedals</a>
              </div>
              
              <!-- Wantlist Matches Section (Sample) -->
              <h2 style="color: #4A5759; font-size: 22px; margin: 45px 0 15px 0; font-family: 'Nunito', sans-serif; font-weight: 700;">Pedals From Your Wantlist</h2>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                Woohoo! Someone listed a pedal you've been looking for!
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif; text-align: center; font-style: italic; color: #9ca3af;">
                [Wantlist matches would appear here based on user's Wantlist]
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif; text-align: center; font-weight: 600;">
                Click on the pedal listing to make a custom trade or cash offer!
              </p>
              
              <!-- Trade Opportunities Section (Sample) -->
              <h2 style="color: #4A5759; font-size: 22px; margin: 45px 0 15px 0; font-family: 'Nunito', sans-serif; font-weight: 700;">Trade Opportunities</h2>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0; font-family: 'Nunito', sans-serif;">
                These users want your pedals! Visit your Trade Opportunities page to see all interested users and their full Pedalboards in order to propose a trade.
              </p>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 20px 0; font-family: 'Nunito', sans-serif; text-align: center; font-style: italic; color: #9ca3af;">
                [Match opportunities would appear here based on users who want your pedals]
              </p>
              
              <div style="margin: 30px 0; text-align: center;">
                <a href="https://pedalxchange.com/recommendations" style="display: inline-block; background-color: #C9A227; color: #ffffff; padding: 14px 28px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; font-family: 'Nunito', sans-serif;">View All Trade Opportunities</a>
              </div>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 30px 0 20px 0; font-family: 'Nunito', sans-serif;">
                Don't miss out on these opportunities! Log in to PedalxChange to explore these listings and start trading.
              </p>
              
              <div style="margin: 30px 0; text-align: center;">
                <a href="https://pedalxchange.com/dashboard" style="display: inline-block; background-color: #5A9ECB; color: #ffffff; padding: 14px 28px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; font-family: 'Nunito', sans-serif;">Go to Dashboard</a>
              </div>
              
              <p style="color: #4A5759; font-size: 16px; line-height: 1.6; margin: 30px 0 20px 0; font-family: 'Nunito', sans-serif;">
                If you have any questions, please reach out to our team at <a href="mailto:contact@pedalxchange.com" style="color: #5A9ECB; text-decoration: none;">contact@pedalxchange.com</a>.
              </p>
              
              <p style="color: #6b7280; font-size: 14px; line-height: 1.6; margin: 20px 0 0 0; font-family: 'Nunito', sans-serif;">
                Happy Trading,<br>
                The PedalxChange Team
              </p>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td style="padding: 20px 30px; background-color: #f9fafb; text-align: center; border-top: 1px solid #e5e7eb;">
              <p style="color: #6b7280; font-size: 12px; margin: 0 0 10px 0; font-family: 'Nunito', sans-serif;">
                © ${new Date().getFullYear()} PedalxChange. All rights reserved.
              </p>
              <p style="color: #9ca3af; font-size: 11px; margin: 0 0 10px 0; font-family: 'Nunito', sans-serif;">
                You're receiving this email because you have an account on PedalxChange. This is an automated message. Please do not reply to this email.
              </p>
              <p style="color: #9ca3af; font-size: 11px; margin: 0; font-family: 'Nunito', sans-serif;">
                <a href="#" style="color: #9ca3af; text-decoration: underline;">Unsubscribe from the bi-weekly Wantlist update</a>
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `;

  const biWeeklyEmailText = `Hey TestUser, check out the latest additions

While you've been gone, here's some of the latest inventory being added to PXC.

Click below to check out all the great things being added to the platform available for trade or purchase.

Browse Pedals: https://pedalxchange.com/latest-pedals

PEDALS FROM YOUR WANT LIST
Pedals you've been looking for have been added to the platform. Check them out!

View Your Wantlist: https://pedalxchange.com/wantlist

TRADE OPPORTUNITIES
These users want pedals you have! Check out what they're offering on your dashboard.

View All Trade Opportunities: https://pedalxchange.com/recommendations

Don't miss out on these opportunities! Log in to PedalxChange to explore these matches and start trading.

Go to Dashboard: https://pedalxchange.com/dashboard

If you have any questions, please reach out to our team at contact@pedalxchange.com.

Happy Trading,

The PedalxChange Team

---
© ${new Date().getFullYear()} PedalxChange. All rights reserved.
You're receiving this email because you have an account on PedalxChange. This is an automated message. Please do not reply to this email.`.trim();

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '30px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <h1 style={{ color: '#111827', marginBottom: '10px' }}>📧 Email Preview</h1>
        <p style={{ color: '#6b7280', marginBottom: '30px' }}>Preview your email templates before deployment</p>

        <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '6px', padding: '15px', marginBottom: '20px' }}>
          <h3 style={{ color: '#1e40af', marginBottom: '10px', fontSize: '16px' }}>ℹ️ Instructions</h3>
          <p style={{ color: '#1e3a8a', fontSize: '14px', lineHeight: '1.6' }}>
            This page shows previews of all email templates. 
            You can toggle between HTML and plain text versions. 
            The Browse Pedals grid uses real data from Firestore. Match sections in the bi-weekly email show placeholders.
          </p>
        </div>

        {/* Bi-Weekly Match Email (NEW - shown first) */}
        <div style={{ marginBottom: '50px', border: '2px solid #C9A227', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ backgroundColor: '#FFFBEB', padding: '15px 20px', borderBottom: '2px solid #C9A227', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontWeight: 'bold', color: '#92400E' }}>⭐ 3. Bi-Weekly Email (Browse Pedals + Matches - sent regularly)</div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => setBiWeeklyView('html')}
                style={{
                  padding: '6px 12px',
                  border: '1px solid #d1d5db',
                  background: biWeeklyView === 'html' ? '#C9A227' : 'white',
                  color: biWeeklyView === 'html' ? 'white' : '#111827',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                HTML
              </button>
              <button
                onClick={() => setBiWeeklyView('text')}
                style={{
                  padding: '6px 12px',
                  border: '1px solid #d1d5db',
                  background: biWeeklyView === 'text' ? '#C9A227' : 'white',
                  color: biWeeklyView === 'text' ? 'white' : '#111827',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                Text
              </button>
            </div>
          </div>
          <div style={{ padding: '20px', backgroundColor: 'white' }}>
            {biWeeklyView === 'html' ? (
              <iframe
                srcDoc={biWeeklyEmailHTML}
                style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: '4px', minHeight: '900px' }}
                title="Bi-Weekly Match Email HTML Preview"
              />
            ) : (
              <pre style={{
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                backgroundColor: '#f9fafb',
                padding: '15px',
                borderRadius: '4px',
                fontSize: '13px',
                lineHeight: '1.6',
                margin: 0
              }}>
                {biWeeklyEmailText}
              </pre>
            )}
          </div>
        </div>

        {/* Welcome Email */}
        <div style={{ marginBottom: '50px', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ backgroundColor: '#f9fafb', padding: '15px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontWeight: 'bold', color: '#111827' }}>1. Welcome Email (Sent after signup completion)</div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => setWelcomeView('html')}
                style={{
                  padding: '6px 12px',
                  border: '1px solid #d1d5db',
                  background: welcomeView === 'html' ? '#C9A227' : 'white',
                  color: welcomeView === 'html' ? 'white' : '#111827',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                HTML
              </button>
              <button
                onClick={() => setWelcomeView('text')}
                style={{
                  padding: '6px 12px',
                  border: '1px solid #d1d5db',
                  background: welcomeView === 'text' ? '#C9A227' : 'white',
                  color: welcomeView === 'text' ? 'white' : '#111827',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                Text
              </button>
            </div>
          </div>
          <div style={{ padding: '20px', backgroundColor: 'white' }}>
            {welcomeView === 'html' ? (
              <iframe
                srcDoc={welcomeEmailHTML}
                style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: '4px', minHeight: '600px' }}
                title="Welcome Email HTML Preview"
              />
            ) : (
              <pre style={{
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                backgroundColor: '#f9fafb',
                padding: '15px',
                borderRadius: '4px',
                fontSize: '13px',
                lineHeight: '1.6',
                margin: 0
              }}>
                {welcomeEmailText}
              </pre>
            )}
          </div>
        </div>

        {/* Follow-up Email */}
        <div style={{ marginBottom: '50px', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ backgroundColor: '#f9fafb', padding: '15px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontWeight: 'bold', color: '#111827' }}>2. Follow-up Email (Sent 3 days after signup if no pedal listed)</div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => setFollowUpView('html')}
                style={{
                  padding: '6px 12px',
                  border: '1px solid #d1d5db',
                  background: followUpView === 'html' ? '#C9A227' : 'white',
                  color: followUpView === 'html' ? 'white' : '#111827',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                HTML
              </button>
              <button
                onClick={() => setFollowUpView('text')}
                style={{
                  padding: '6px 12px',
                  border: '1px solid #d1d5db',
                  background: followUpView === 'text' ? '#C9A227' : 'white',
                  color: followUpView === 'text' ? 'white' : '#111827',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                Text
              </button>
            </div>
          </div>
          <div style={{ padding: '20px', backgroundColor: 'white' }}>
            {followUpView === 'html' ? (
              <iframe
                srcDoc={followUpEmailHTML}
                style={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: '4px', minHeight: '600px' }}
                title="Follow-up Email HTML Preview"
              />
            ) : (
              <pre style={{
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                backgroundColor: '#f9fafb',
                padding: '15px',
                borderRadius: '4px',
                fontSize: '13px',
                lineHeight: '1.6',
                margin: 0
              }}>
                {followUpEmailText}
              </pre>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;
